import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/common/Button';
import PreviewPhoto from '../../../assets/images/RestaurantWizardHeader.png';
import { PAGE_NEW_PAGE, PAGE_PAGES } from '../../../constants/UriConstants';
import { CUSTOM_PAGE_TEMPLATES, CustomPageTemplate } from '../../../utils/customPages';

const TEMPLATE_LABELS: Record<CustomPageTemplate, string> = {
  'cover-photo': 'Text with cover photo',
  sections: 'Multiple sections',
  text: 'All text'
};

const SHORT_TEXT =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.';

const TemplatePreview = ({ template }: { template: CustomPageTemplate }) => {
  if (template === 'sections') {
    return (
      <div className="template-preview template-preview--sections">
        <p className="template-preview-title">PAGE TITLE</p>
        {[0, 1, 2].map((row) => (
          <div key={row} className={`template-preview-row ${row % 2 ? 'template-preview-row--reversed' : ''}`}>
            <img src={PreviewPhoto} alt="" />
            <div>
              <p className="template-preview-heading">Lorem Ipsum</p>
              <p className="template-preview-text">{SHORT_TEXT}</p>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="template-preview">
      {template === 'cover-photo' && <img className="template-preview-cover" src={PreviewPhoto} alt="" />}
      <p className="template-preview-title">PAGE TITLE</p>
      <p className="template-preview-text">
        {template === 'text' ? `${SHORT_TEXT} ${SHORT_TEXT} ${SHORT_TEXT}` : SHORT_TEXT}
      </p>
    </div>
  );
};

const AddPageTemplatePage = () => {
  const navigate = useNavigate();
  const [selected, setSelected] = useState<CustomPageTemplate | null>(null);

  return (
    <div className="add-page-template-container">
      <h1 className="add-page-template-heading">Choose a Page Template</h1>
      <div className="add-page-template-options">
        {CUSTOM_PAGE_TEMPLATES.map((template) => (
          <button
            key={template}
            type="button"
            aria-label={TEMPLATE_LABELS[template]}
            aria-pressed={selected === template}
            className={`add-page-template-option ${selected === template ? 'add-page-template-option--selected' : ''}`}
            onClick={() => setSelected(template)}
          >
            <TemplatePreview template={template} />
          </button>
        ))}
      </div>
      <div className="add-page-template-actions">
        <Button className="add-page-template-cancel-button" onClick={() => navigate(`/${PAGE_PAGES}`)}>
          CANCEL
        </Button>
        <Button
          className="add-page-template-next-button"
          isDisabled={!selected}
          onClick={() => navigate(`/${PAGE_NEW_PAGE}/${selected}`)}
        >
          NEXT
        </Button>
      </div>
    </div>
  );
};

export default AddPageTemplatePage;
